$(document).ready(function () {

    $("body").off("submit").on("submit","form.ContactForm , form.AdvantageForm", function (e) {

        $form = $(this);
        if ($(".AvdInput button").length>0)
        {
            $(".AvdInput button").text("gönderiliyor lütfen bekleyiniz.");
        }
        if ($(".SendFormButton .btn").length > 0)
        {
            $(".SendFormButton .btn").val("gönderiliyor lütfen bekleyiniz.");
        }
  
        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                     $("#AlertResult").show().find("span").html(dt.IslemSonucAciklama);
                    $form.hide();

                }
                else {

                    //$("#AlertResult").addClass("alert-danger");
                    //$("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                    $("#AlertResult").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
         
        e.preventDefault();
        return false;

    });

    $("form.AdvantageForm label input").live("change", function (e) {

        var solution = $('input[name=FindSolution]:checked', '.AdvantageForm').val();

        if (solution == "False" || solution == false) {

            $(".AvdInput, .AvdInput div, .AvdInput textarea").show();
            var firstval = "bilgiler yardımcı oldu teşekkür ederim.";
            $(".AvdInput textarea").val($(".AvdInput textarea").val().replace(firstval, ""));
        }

        if (solution == "True") {

            $(".AvdInput, .AvdInput button").show();
            $(".AvdInput div, .AvdInput textarea").hide();
            $(".AvdInput textarea").val("bilgiler yardımcı oldu teşekkür ederim.");
            $("form.AdvantageForm").submit();
        }

    });

    $(".AdvList li").live("click", function (e) {

        $(this).find("> div").toggle();

    });
});